import React, { useState } from 'react';
import { ActivityTitleStep } from '../components/ActivityTitleStep';
import { Activity, ActivityStep } from '../Activity';
import { ActivityTypeProps } from '../types';
import { CountGame } from '../components/CountGame';

interface SpellingOralSegmentingStepProps extends ActivityTypeProps {
  index: number;
  total: number;
  segmentation: string;
}

const SpellingOralSegmentingStep = ({
  activity,
  mode,
  wrapperClassName,
  isPreview,
  index,
  total,
  segmentation,
}: SpellingOralSegmentingStepProps) => {
  const [selected, setSelected] = useState<number | undefined>();

  return (
    <ActivityStep
      stepIdentifier={`${activity.id}-${index}-1`}
      activity={activity}
      mode={mode}
      stepNumber={index + 1}
      totalSteps={total}
      wrapperClassName={wrapperClassName}
      isPreview={isPreview}
      usePanel
      title={`What are the sounds in the word? How many are there?`}
      showTitle={mode === 'TEACH'}
      showActivityPagination={false}
      getActivityResponseMetaData={() => ({
        text: segmentation,
        points: selected ? `${selected}` : null,
      })}
    >
      <CountGame
        segmentation={segmentation}
        selected={selected}
        setSelected={setSelected}
      />
    </ActivityStep>
  );
};

export const SpellingOralSegmenting = ({
  activity,
  mode,
  wrapperClassName,
  isPreview,
}: ActivityTypeProps) => {
  if (
    !activity.wordSegmentations ||
    !Array.isArray(activity.wordSegmentations)
  ) {
    throw new Error('Segmentations are required for this activity');
  }

  const { wordSegmentations } = activity;

  return (
    <Activity
      steps={[
        ...(mode === 'TEACH'
          ? [
              <ActivityTitleStep
                key={`${activity.id}-title`}
                activity={activity}
                mode={mode}
                wrapperClassName={wrapperClassName}
                isPreview={isPreview}
                index={0}
                total={wordSegmentations.length + 1}
                parrotType="squawking"
              />,
            ]
          : []),
        ...wordSegmentations.flatMap((segmentation, index) => [
          <SpellingOralSegmentingStep
            key={`${activity.id}-${index}-1`}
            activity={activity}
            mode={mode}
            wrapperClassName={wrapperClassName}
            isPreview={isPreview}
            index={mode === 'TEACH' ? index + 1 : index}
            total={
              mode === 'TEACH'
                ? wordSegmentations.length + 1
                : wordSegmentations.length
            }
            segmentation={segmentation}
          />,
        ]),
      ]}
    />
  );
};
